(function () {
    require('sweetalert');
    jQuery('.card-options a').click(function (e) {
        var url = this.href;
        e.preventDefault();
        swal(
            {
                title: 'Are you sure?',
                text: 'Are you sure you would like to delete this card?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, delete it!',
                closeOnConfirm: true,
            },
            function () {
                window.location = url;
            }
        );
    });
})();
